import { Box, Typography } from "@mui/material";
import { AppointmentParticipantDetail } from "./appointmentParticipantTypes";
import ParticipantContactStack from "./ParticipantContactStack";

type Props = {
  index: number;
  participant: AppointmentParticipantDetail;
};

const AppointmentParticipantDetailStack = ({ index, participant }: Props) => {
  const suffix = [
    participant.code && ` - ${participant.code}`,
    participant.cohortName && ` (${participant.cohortName})`,
  ]
    .filter(Boolean)
    .join("");

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
      <Typography variant="body2" fontWeight={500} color="text.primary">
        {index}.
      </Typography>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" fontWeight={500} color="text.primary">
          {participant.name}
          {suffix}
        </Typography>
        <ParticipantContactStack participant={participant} showName={false} />
      </Box>
    </Box>
  );
};

export default AppointmentParticipantDetailStack;
